<template>
  <div class="col-l-12 col-m-12 col-12 gdwrapper" v-for="(value, index) in songRegistration.publisherInfo" :key="index">
    <FormInput :data-field="'name-'+ index" place-holder="PubName" v-model="value.pubName" />
    <FormInput :data-field="'ipnumber-'+ index" place-holder="IP Number" v-model="value.ipNumber" />
    <EnumInput :data-field="'capacity-'+ index" place-holder="Capacity" :items="PublisherCapacity" v-model="value.capacity" />
    <div class="col-l-3 col-m-4 col-5">
      <label :for="'controlled'+index">Controlled-{{ index }}</label>
    </div>
    <RadioInput :items="radioGroupOptions" :data-field="'controlled-'+ index" place-holder="Controlled" v-model="value.controlled" />
    <FormInput :data-field="'affiliation-'+ index" place-holder="Pub Affiliation" v-model="value.affiliation" />
    <hr />
  </div>
</template>
<script setup>
  import EnumInput from '@/components/felements/EnumInput.vue';
  import FormInput from '@/components/felements/FormInput.vue';
  import RadioInput from '@/components/felements/RadioInput.vue';
  import { PublisherCapacity} from '@/models/SongRegistration';
  import { defineModel } from 'vue';
  const radioGroupOptions = [{name: 'yes', value: true}, {name: 'no', value: false},]
  const songRegistration = defineModel('songRegistration')
</script>
<style lang="css" scoped>
  .pubminiform {
    margin-bottom: 15px;
  }
</style>